import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SSO_CONFIG } from '@core/config/sso.config';

export interface GoogleUser {
  id: string;
  name: string;
  email: string;
  picture?: string;
}

@Injectable({ providedIn: 'root' })
export class GoogleAuthService {
  readonly isAuthenticated$: Observable<boolean> = of(false);
  readonly isAuthenticated = false;

  async login(): Promise<void> {
    const providerConfig = SSO_CONFIG.google;
    // Redirect to google OAuth endpoint
    window.location.href = providerConfig.redirectUri;
  }

  async logout(): Promise<void> {
    // Handle google logout
  }

  getCurrentUser(): GoogleUser | null {
    return null;
  }

  signInWithRedirect(): void {
    console.warn('GoogleAuthService: signInWithRedirect not implemented');
  }

  signOut(): void {
    console.warn('GoogleAuthService: signOut not implemented');
  }
}
